export const GET_QUOTE_LIST_SUCCESS = "GET_QUOTE_LIST_SUCCESS";
export const GET_QUOTE_SETTING_LIST_SUCCESS = "GET_QUOTE_SETTING_LIST_SUCCESS";
export const GET_DIRECT_DEBIT_CONFIGURATION_SUCCESS = "GET_DIRECT_DEBIT_CONFIGURATION_SUCCESS";
export const UPDATE_QUOTE_OPERATION_DATA = "UPDATE_QUOTE_OPERATION_DATA";
export const UPDATE_GENERATED_PAYMENT_REF = "UPDATE_GENERATED_PAYMENT_REF";